import React, {useState} from "react";
import "./FundingSection.scss";

import PlansSection from "../PlansSection/PlansSection";

const FundingSection = ({selectedPlanId, handleScrollToCheckout}) => {
  return (
    <>
      <div className="fundingSectionContainer">
        <div className="fundingSectionWrapper">
          <PlansSection
            selectedPlanId={selectedPlanId}
            handleScrollToCheckout={handleScrollToCheckout}
          />
        </div>
      </div>
    </>
  );
};

export default FundingSection;
